import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { chargeSubcategoryQueries } from '@/services/charges/charges.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useAddSubcategory = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('addSubcategory', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: chargeSubcategoryQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};

export const useUpdateSubcategory = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updateSubcategory', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: chargeSubcategoryQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};

export const useToggleSubcategoryStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('toggleSubcategoryStatus', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: chargeSubcategoryQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};
